import { DefaultService } from '@/services/DefaultService';

export default class AssProdutoEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assprodutoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllPromotor(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/promotor/empresa/assprodutoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assprodutoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(assprodutoempresa) {
        return this._http.post(`${this._env}/ven/empresa/assprodutoempresa/updatesituacao`, assprodutoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoPromotor(assprodutoempresa) {
        return this._http.post(`${this._env}/promotor/empresa/assprodutoempresa/updatesituacao`, assprodutoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assprodutoempresa) {
        return this._http.post(`${this._env}/agro/empresa/assprodutoempresa/updatesituacao`, assprodutoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findProdutosNaoAssociadosVendas(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assprodutoempresa/produtosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findProdutosNaoAssociadosPromotor(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/promotor/empresa/assprodutoempresa/produtosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findProdutosNaoAssociadosAgro(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assprodutoempresa/produtosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(listaprodutos) {
        return this._http.post(`${this._env}/ven/empresa/assprodutoempresa`, listaprodutos, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    savePromotor(listaprodutos) {
        return this._http.post(`${this._env}/promotor/empresa/assprodutoempresa`, listaprodutos, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(listaprodutos) {
        return this._http.post(`${this._env}/agro/empresa/assprodutoempresa`, listaprodutos, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateVendas(assprodutoempresa) {
        return this._http.post(`${this._env}/ven/empresa/assprodutoempresa/update`, assprodutoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updatePromotor(assprodutoempresa) {
        return this._http.post(`${this._env}/promotor/empresa/assprodutoempresa/update`, assprodutoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateAgro(assprodutoempresa) {
        return this._http.post(`${this._env}/agro/empresa/assprodutoempresa/update`, assprodutoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociados(column, order, page, limit, idproduto, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/produto/assprodutoempresa/empresasnaoassociadas?page=${page}&limit=${limit}&column=${column}&order=${order}&idproduto=${idproduto}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    salvarAssociados(lista) {
        return this._http.post(`${this._env}/ven/produto/assprodutoempresa`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    findByIdProduto(column, order, page, limit, situacao, idproduto, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/produto/assprodutoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idproduto=${idproduto}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}
    find(idassprodutoempresa) {
        return this._http.get(`${this._env}/ven/produto/assprodutoempresa/${idassprodutoempresa}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}